import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { $b } from '../../../libs/browser_utils.js';
import { CommunicationInterfaceService } from '../communicationInterface/communication-interface.service';

@Injectable({
  providedIn: 'root',
})
export class FileTransferService {
  private baseUrl = 'https://tmac.tetherfilabs.com'; // https://demo2.tetherfilabs.com:55443/FileUploadDownload/api/FileUpload
  private SessionId = 'dev_test_123';
  constructor(private http: HttpClient, private commInterface: CommunicationInterfaceService) {}

  uploadFiles(fileList) {
    const formdata = new FormData();
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < fileList.length; i++) {
      const uploadFile = fileList[i];
      formdata.append(uploadFile.name, uploadFile);
    }
    formdata.append('SessionId', $b.GetSessionStorage('SessionId') || this.SessionId);
    return this.http.post(
      `${this.baseUrl}/FileUploadDownload/api/FileUpload`,
      formdata
    );
  }

  getFileUploadPacket(type, replyId, message, fileName) {
    return {
      messageId: `c_${Date.now()}`,
      type,
      replyId,
      message,
      chatSessionId : $b.GetSessionStorage('SessionId') || this.SessionId,
      fileName,
    };
  }

  downloadMedia(url) {
    this.http.get(url).subscribe(res => {
      console.log(res);
    }, err => {
      console.log(err);
    });
  }

}
